import React, { Component } from "react";
import Store from "./../../content/Store";
import contentify from "../../content/Contentify";
import style from "../../assets/css/modules/cover/cover.css";
import ShadowedContainer from "../shared/containers/ShadowedContainer";
import Article from "../shared/Article";
import SummaryDetail from "../shared/groups/SummaryDetail";
import SummaryDetailRow from "../shared/groups/SummaryDetailRow";
import { connect } from "react-redux";
import ThumbnailList from "../../components/home/ThumbnailList";
import HelpSection from "../shared/HelpSection";
import { Redirect } from "react-router";
import { Paths } from "./../../constants/UrlConstants";
import DateHelper from "./../../helpers/DateHelper";
import CoverSummaryRequired from "./CoverSummaryRequired";
import DropDown from "../shared/form/DropDown";
import MemberHelper from "../../helpers/MemberHelper";
import CoverExcessSummary from "./CoverExcessSummary";
import CoverBenefitSection from "./CoverBenefitSection";
import InfoBox from "../shared/InfoBox";
import { shouldShowIfAnySMEModulesMatch } from "./../../helpers/SMEModules/smeModuleHelper";
import { EAPEssential, EAPPremier } from "../../constants/SMEModules";
import { Layouts } from "../../constants/Constants";
import CoverAddAPlanLink from "./CoverAddAPlanLink";
import { stripGP247 } from "../../content/ContentHelper";

function getDropDownItemsFromMembers(members, memberList) {
  return members.map((m) => {
    let member = memberList.find((mem) => mem.SecurityId === m.SecurityId);
    return {
      Name: m.Name,
      Value: m.SecurityId,
      PlanDates:
        member &&
        member.PlanDates &&
        member.PlanDates.map((p) => ({
          Name: p.EffectiveDate + " - " + p.RenewalDate,
          Value: p.EffectiveDate
        })),
      BenefitSummaryYears: member && member.BenefitSummaryYears,
      IsDoubleExcess: member && member.IsDoubleExcess,
      HasSixWeeksBenefit: member && member.HasSixWeeksBenefit,
      HasGuidedOptionBenefit: member && member.HasGuidedOptionBenefit
    };
  });
}

function setSelectedMember(state, props) {
  if (props && props.coverMembersList) {
    let selectedMember =
      (state && state.selectedMember) || props.coverMembersList[0].Value;

    let selectedCoverMember = props.coverMembersList.find(
      (m) => m.Value === selectedMember
    );

    let planDates = selectedCoverMember && selectedCoverMember.PlanDates;

    let selectedPlanDate =
      planDates &&
      (planDates.find((date) => date.Value === state.selectedEffectiveDate) ||
        planDates[0]);

    let selectedBenefitYear =
      selectedPlanDate &&
      selectedCoverMember.BenefitSummaryYears.find(
        (y) => y.EffectiveDate === selectedPlanDate.Value
      );

    return {
      selectedMember: selectedMember,
      selectedEffectiveDate: selectedPlanDate && selectedPlanDate.Value,
      selectedBenefitYear: selectedBenefitYear
    };
  }
  return {};
}

function findSelectedMember(members, securityId) {
  if (!members) {
    return [];
  }
  return members.find((m) => m.Value === securityId);
}

export const mapStateToProps = (state) => {
  const selectedPolicy =
    state.policyReducer && state.policyReducer.selectedPolicy;

  return {
    MembershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    ProductType: selectedPolicy && selectedPolicy.ProductType,
    PolicyStartDate:
      selectedPolicy &&
      DateHelper.getDateInStringFormat(selectedPolicy.PolicyStartDate),
    RenewalDate:
      selectedPolicy &&
      DateHelper.getDateInStringFormat(selectedPolicy.RenewalDate),
    showRenewalInformation:
      selectedPolicy && selectedPolicy.ShowRenewalInformation,
    otherMembers:
      selectedPolicy &&
      selectedPolicy.Members &&
      selectedPolicy.Members.filter(
        (member) => member.IsLoggedInMember === false
      ).map((member) => ({
        FullName: member.FullName,
        DateOfBirth: member.DateOfBirth
      })),
    IsFormat2: selectedPolicy && selectedPolicy.IsFormat2,
    IsSaga: selectedPolicy && selectedPolicy.IsSaga,
    IsPolicyHolder: MemberHelper.getCurrentLoggedInMemberFromPolicy(
      selectedPolicy
    ).IsPolicyHolder,
    coverMembersList:
      selectedPolicy &&
      selectedPolicy.coverMembersList &&
      getDropDownItemsFromMembers(
        selectedPolicy.coverMembersList,
        selectedPolicy.Members
      ),

    IsSMEModular: selectedPolicy.IsSMEModular,
    IsIndividual: selectedPolicy.IsIndividual,
    EAPPremier: shouldShowIfAnySMEModulesMatch(selectedPolicy, [EAPPremier]),
    EAPEssential: shouldShowIfAnySMEModulesMatch(selectedPolicy, [
      EAPEssential
    ]),
    IsHOL: state.layoutReducer && state.layoutReducer.layout === Layouts.HOL,
    IsChildOnlyPolicy: selectedPolicy.IsChildOnlyPolicy,
    IsLapsed: selectedPolicy.IsLapsed,
  };
};

export class CoverDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.onCoverMemberChange = this.onCoverMemberChange.bind(this);
    this.onPlanDatesChange = this.onPlanDatesChange.bind(this);
  }
  static content = Store.Cover;

  onCoverMemberChange(value) {
    this.setState({ selectedMember: value });
  }

  onPlanDatesChange(value) {
    this.setState({ selectedEffectiveDate: value });
  }

  static getDerivedStateFromProps(props, state) {
    return setSelectedMember(state, props);
  }

  render() {
    let helpSetContent;
    helpSetContent = this.props.IsIndividual ? this.props.content.HelpSection.HelpSetForHarpaIND :
      this.props.content.HelpSection.HelpSetForHarpa;

    if (this.props.IsSMEModular) {
      helpSetContent = this.props.content.HelpSection.HelpSetForSMEModular;
    }

    if (this.props.IsHOL) {
      helpSetContent = this.props.IsIndividual ? this.props.content.HelpSection.HelpSetForHOLIND :
        this.props.content.HelpSection.HelpSetForHOL;
    }

    const selectedMember = findSelectedMember(
      this.props.coverMembersList,
      this.state.selectedMember
    );

    return this.props.IsSaga ? (
      <Redirect to={Paths.MembershipInfoSaga} />
    ) : this.props.IsFormat2 ? (
      <Redirect to={Paths.CoverDocuments} />
    ) : (
      <ShadowedContainer>
        <div className="row">
          <div className={"col-lg-8 " + style.articleDescription}>
            <Article
              header={this.props.content.CoverDetailsHeader}
              body={this.props.content.CoverDetailsBody}
            />
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-lg-5">
            <SummaryDetail>
              <SummaryDetailRow
                title={this.props.content.ProductName}
                value={this.props.ProductType}
              />
              <SummaryDetailRow
                title={this.props.content.MembershipNumber}
                value={this.props.MembershipNumber}
              />
              <SummaryDetailRow
                title={this.props.content.PolicyStartDate}
                value={this.props.PolicyStartDate}
              />
              {!this.props.IsLapsed &&<SummaryDetailRow
                title={this.props.content.RenewalDate}
                value={this.props.RenewalDate}
              />}
            </SummaryDetail>
          </div>
          {this.props.otherMembers && this.props.otherMembers.length > 0 ? (
            <div className={" mt-2 col-lg-5 offset-lg-2 " + style.otherPeople}>
              <h3>{this.props.content.OtherMembersOnYourPlan}</h3>
              <SummaryDetail>
                <SummaryDetailRow header title="Name" value="Date of birth" />
                {this.props.otherMembers &&
                  this.props.otherMembers.map((row, key) => (
                    <SummaryDetailRow
                      title={row.FullName}
                      value={DateHelper.getDateInStringFormat(row.DateOfBirth)}
                      key={key}
                      icon="icon-man-blue"
                    />
                  ))}
              </SummaryDetail>
            </div>
          ) : null}
        </div>
        <hr />
        <div className="mb-3">
          <CoverAddAPlanLink />
        </div>
        <CoverSummaryRequired>
          <div className={"row " + style.coverSelection}>
            <div className={"col-12 " + style.coverDescription}>
              {this.props.IsPolicyHolder
                ? this.props.content.CoverMembersBody
                : this.props.content.CoverMembersDependantBody}
            </div>

            {this.props.coverMembersList &&
              this.props.coverMembersList.length > 1 ? (
              <div className={"col-lg-6 " + style.dropdown}>
                <DropDown
                  items={this.props.coverMembersList}
                  id="coverMembers"
                  onChange={this.onCoverMemberChange}
                  label={this.props.content.OtherMembersOnYourPlan}
                />
              </div>
            ) : null}

            <CoverSummaryRequired securityId={this.state.selectedMember}>
              <div className={"col-lg-6 " + style.dropdown}>
                {selectedMember && selectedMember.PlanDates ? (
                  <DropDown
                    items={selectedMember.PlanDates}
                    id="planDates"
                    label={this.props.content.PlanDatesLabel}
                    onChange={this.onPlanDatesChange}
                  />
                ) : null}
              </div>
            </CoverSummaryRequired>
          </div>
          <hr />

          {this.state.selectedBenefitYear ? (
            <React.Fragment>
              <p id="lastUpdatedDateAndTime">
                {this.props.content.LastUpdatedDateTimeDescription}
                {DateHelper.getDateAndTimeInStringFormat(
                  this.state.selectedBenefitYear.LastUpdatedDateAndTime
                )}
              </p>
              <hr />
              <CoverExcessSummary
                excess={this.state.selectedBenefitYear}
                isDoubleExcess={this.props.showRenewalInformation}
              />
              <hr />
              <div className="mb-3 row">
                <div className="col-12">
                  <h2>{this.props.content.BenefitTitle}</h2>
                  <p>{this.props.content.BenefitDescription}</p>
                </div>
              </div>
              {selectedMember.HasSixWeeksBenefit ? (
                <div className="col-12">
                  <InfoBox
                    iconClass={"icon-functional-help"}
                    children={this.props.content.SixWeekOptionContent}
                    className="my-4"
                  />
                </div>
              ) : null}
              {selectedMember.HasGuidedOptionBenefit ? (
                <div className={"col-12 " + style.guidedDescription}>
                  <InfoBox
                    iconClass={"icon-functional-help"}
                    children={this.props.content.GuidedOptionDescription}
                    className={"my-4"}
                  />
                </div>
              ) : null}

              <div className="col-12">
                {this.state.selectedBenefitYear.Benefits &&
                  this.state.selectedBenefitYear.Benefits.map(
                    (benefit, index) => (
                      <CoverBenefitSection key={index} benefit={benefit} ProductType ={this.props.ProductType}/>
                    )
                  )}
              </div>

              {this.state.selectedBenefitYear.HasTravelOption ? (
                <div className={"mb-3 row " + style.travelCover}>
                  <div className="col-12">
                    <h3>{this.props.content.TravelCoverTitle}</h3>
                    {this.props.content.TravelCoverDescription}
                  </div>
                </div>
              ) : null}

              {this.props.EAPEssential || this.props.EAPPremier ? (
                <div className={"mb-3 row " + style.travelCover}>
                  <div className="col-12">
                    {this.props.EAPEssential ? (
                      <h3>{this.props.content.EAPEssentialTitle}</h3>
                    ) : (
                      <h3>{this.props.content.EAPPremierTitle}</h3>
                    )}
                    {this.props.content.EAPDescription}
                  </div>
                </div>
              ) : null}
            </React.Fragment>
          ) : null}
        </CoverSummaryRequired>
        <div className="mb-4 row">
          <div className="col-lg-12">
            <ThumbnailList
              Heading={this.props.content.ThumbnailListHeading}
              Description={this.props.content.ThumbnailListDescription}
              Items={stripGP247(this.props.IsChildOnlyPolicy, this.props.content.ThumbNailListItems)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <HelpSection
              HeadingLinkText={Store.Cover.HelpSection.HeadingLinkText}
              HeadingLinkTo={Store.Cover.HelpSection.HeadingLinkTo}
              MoreHelpLinkText={Store.Cover.HelpSection.MoreHelpLinkText}
              MoreHelpLinkTo={Store.Cover.HelpSection.MoreHelpLinkTo}
              HelpSet={helpSetContent}
            />
          </div>
        </div>
      </ShadowedContainer>
    );
  }
}
export default connect(mapStateToProps)(contentify(CoverDetails));
